import { useCallback, useEffect, useState } from 'react'
import { getApiErrorMessage } from '../../../shared/api/apiClient'
import { brandExtractionService } from '../services/brandExtractionService'

// Read each time the tab opens, so a profile published since the page loaded
// shows up without a reload.
export const useBrandProfile = ({ brand, isEnabled }) => {
  const [error, setError] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [isSaving, setIsSaving] = useState(false)
  const [profile, setProfile] = useState(null)

  const loadProfile = useCallback(() => {
    setError('')
    setIsLoading(true)
    return brandExtractionService
      .getProfile(brand)
      .then(setProfile)
      .catch((requestError) =>
        setError(
          getApiErrorMessage(
            requestError,
            'The brand profile could not be loaded.',
          ),
        ),
      )
      .finally(() => setIsLoading(false))
  }, [brand])

  useEffect(() => {
    if (isEnabled) loadProfile()
  }, [isEnabled, loadProfile])

  // Saves the edited sections, then re-reads the profile so the page shows
  // the new version. Resolves to an error message, or '' on success.
  const saveSections = async (sections) => {
    setIsSaving(true)
    try {
      await brandExtractionService.updateProfile(brand, sections)
      await loadProfile()
      return ''
    } catch (requestError) {
      return getApiErrorMessage(
        requestError,
        'The brand profile could not be saved.',
      )
    } finally {
      setIsSaving(false)
    }
  }

  return { error, isLoading, isSaving, profile, saveSections }
}
